import { useEffect, useState } from 'react';

const FloatingPopup = ({ title, children, onClose, width = 'max-w-4xl' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => {
        onClose(); // call only after animation
      }, 200); // match transition duration
      return () => clearTimeout(timer); // clean on unmount
    }
  }, [visible, onClose]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-200 ${visible ? 'bg-black bg-opacity-50' : 'bg-black bg-opacity-0 pointer-events-none'
        }`}
    >
      <div
        className={`bg-white rounded-lg shadow-lg w-full ${width} p-6 relative transform transition-all duration-200 ease-out ${visible ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-5 opacity-0 scale-95'
          }`}
      >
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={handleClose}
        >
          &#10005;
        </button>
        {title && <h2 className="text-xl font-semibold text-red-600 mb-4">{title}</h2>}
        {children}
      </div>
    </div>
  );
};

export default FloatingPopup;
